import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
  selector: 'i, [rlAriaHidden]'
})
export class AriaHiddenDirective implements OnInit{  
  
  @Input('rlAriaHidden') set isHidden(isHidden : boolean){
    this.ariaHidden = isHidden;
  }

  @HostBinding("attr.aria-hidden") ariaHidden : boolean;

  ngOnInit(): void {
    this.ariaHidden = this.ariaHidden || true;
  }

}
